<div class="message-confirm" *ngIf="isDeliveryDLConfirmation">
  <h2 class="title">Дякуємо!</h2>
  <b>
    Ваше замовлення № {{ data.data.order_id }} прийняте
  </b>
  <p class="text-center">Відвантаження товару здійснюється по <b>повній передоплаті</b></p>
  <b class="text-center alert">
    Прийом платежів здійснюється за реквізитами які вказані в меню -> реквізити.<br>Після оплати необхідно повідомляти
    про оплату на сайті!
  </b>
  <ng-container *ngIf="data.data.global_settings_status_otgrujaem == 'on' && (data.data.status_otgrujaem || (data.data.settings_status_otgrujaem && data.data.settings_status_otgrujaem == '1')) else unpaidConditions">
    <b class="text-center alert">
      Курсова різниця - ризики замовника!
    </b>
  </ng-container>
  <ng-template #unpaidConditions>
    <b class="text-center alert">
      Неоплачене замовлення на вказану дату відправки, буде автоматично розформоване.
    </b>
  </ng-template>
  <p class="text-center">Оформлене та оплачене замовлення <span class="alert">до {{ data.data.tiltime }}</span>
    відправляється в <span
      class="alert">той же день</span></p>
  <p class="text-center">Замовлення оформлені <span class="alert">після {{ data.data.tiltime }}</span> будуть
    відправлені <span class="alert">наступного робочого дня</span></p>
  <p class="text-center">Номер декларації, після відправки, буде прописаний на сайті в замовленнях.</p>
  <div class="row items-center form_data"
       *ngIf="parseFloat(data.data.calcdebt_summa) > 1 && (
                    parseFloat(data.data.calcdebt_summa) > parseFloat(data.data.delay_summa)
                    || data.data.delay_from && (data.data.delay_from < data.data.delay_days)
              )"
  >
    <div class="column"></div>
    <div class="column shrink textright">
      <b class="comment">
        Прострочена заборгованість!<br>
        Відвантаження вашого замовлення можливе після виконання договірних зобов'язань щодо оплати.
      </b>
    </div>
    <div class="column"></div>
  </div>
  <a routerLink="/account" class="button">Ознайомлений</a>
</div>
